var _rect, _rect2, _polyline, _polyline2, _polyline3, _polyline4, _line, _text, _text2, _line2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    width: 1200,
    height: 675,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "csBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2a2220",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1c1a18",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#csBg)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#800020",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#800020",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#glow)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "72,72 72,140 140,140",
    fill: "none",
    stroke: "#faf7f2",
    strokeWidth: 1.5,
    opacity: 0.18
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "1128,72 1128,140 1060,140",
    fill: "none",
    stroke: "#faf7f2",
    strokeWidth: 1.5,
    opacity: 0.18
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "72,603 72,535 140,535",
    fill: "none",
    stroke: "#faf7f2",
    strokeWidth: 1.5,
    opacity: 0.18
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "1128,603 1128,535 1060,535",
    fill: "none",
    stroke: "#faf7f2",
    strokeWidth: 1.5,
    opacity: 0.18
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 240,
    x2: 760,
    y2: 240,
    stroke: "#800020",
    strokeWidth: 1,
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 278,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fill: "#faf7f2",
    textAnchor: "middle",
    letterSpacing: 5,
    opacity: 0.45
  }, "BRANDING DESIGN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 358,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 72,
    fill: "#faf7f2",
    textAnchor: "middle",
    fontStyle: "italic",
    opacity: 0.92
  }, "Coming Soon")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 388,
    x2: 760,
    y2: 388,
    stroke: "#800020",
    strokeWidth: 1,
    opacity: 0.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 424,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fill: "#faf7f2",
    textAnchor: "middle",
    letterSpacing: 2.5,
    opacity: 0.38
  }, "Case study in progress")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.12513a599bcb1e6c3b7abd1f4452a3ea.svg";
export { ForwardRef as ReactComponent };